import React from 'react';

import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import { Mutation } from 'react-apollo';

import ErrorModal from '../ErrorModal';
import MutationRequest from '../MutationRequest';

export const DELETE_ASSET = gql`
  mutation deleteAsset($assetId: String!) {
    asset {
      deleteAsset(assetId: $assetId)
    }
  }
`;

const deleteAssetRequest = ({ assetId, onError, onSuccessResult }) => (
  <Mutation mutation={DELETE_ASSET}>
    {(deleteAsset, { loading, error, data }) => {
      const variables = {
        assetId,
      };

      if (error) {
        return <ErrorModal error={error} onError={onError} />;
      }
      if (data) {
        onSuccessResult(data.asset.deleteAsset);
      }

      return <MutationRequest isLoading={loading} mutation={deleteAsset} variables={variables} />;
    }}
  </Mutation>
);

deleteAssetRequest.propTypes = {
  assetId: PropTypes.string.isRequired,
  onError: PropTypes.func.isRequired,
  onSuccessResult: PropTypes.func.isRequired,
};

export default deleteAssetRequest;
